import { createAsyncThunk } from "@reduxjs/toolkit";
import { EndPoints } from "../../api/endpoints";
import axiosClient from "../../api/axiosClient";

export type AddProduct = {
  name: string;
  icon: string;
  id: string;
};
export const getProducts = createAsyncThunk(
  "get/products",
  async (_, { rejectWithValue }): Promise<any> => {
    try {
      const response = await axiosClient.get(EndPoints.products);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);

export const addProduct = createAsyncThunk(
  "add/products",
  async (data: AddProduct, { dispatch, rejectWithValue }): Promise<any> => {
    try {
      const response = await axiosClient.put(EndPoints.products, data);
      dispatch(getProducts());
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);

export const updateProduct = createAsyncThunk(
  "update/products",
  async (data: AddProduct, { dispatch, rejectWithValue }): Promise<any> => {
    try {
      const response = await axiosClient.patch(
        `${EndPoints.products}/${data.id}`,
        data
      );
      dispatch(getProducts());
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);

export const deleteProduct = createAsyncThunk(
  "delete/products",
  async (id: string, { dispatch, rejectWithValue }): Promise<any> => {
    try {
      const response = await axiosClient.delete(`${EndPoints.products}/${id}`);
      dispatch(getProducts());
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);
